import { EGeneralStatus } from '@/lib/DBModels';

export function isScratchedRunner(status: EGeneralStatus) {
  return [
    EGeneralStatus.Scratched,
    EGeneralStatus.Voided,
    EGeneralStatus.Abandoned,
  ].includes(status);
}
